const colorApproval = {
    normal: {
        AP: "#5969ff",
        WT: "#F4984E",
        NA: "#999",
    },
    disabled: {
        AP: "#8490fb",
        WT: "#f9a765",
        NA: "#999",
    },
};
module.exports = {
    color: {
        approval: colorApproval,
        background: {
			disabled: "#e9ecef",
			normal: {view: "#f9f9ff", modal: "#fff"}
        },
    },
};
